import React from "react";
import LoginMFAOtp from "./LoginMFAOtp";
import userService from "../../services/userService";

export default class LoginMFA extends React.PureComponent {
  onLoginWithMfa = userInput => {
    this.props.onLoginWithMfa(
      userInput,
      this.props.mfaToken,
      this.props.mfaMechanism
    );
  };

  onResendOtp = () => {
    userService.resendOtp(this.props.mfaToken);
  };

  render() {
    const COMPONENTS = {
      OTP_2FA: LoginMFAOtp
    };

    let Component = COMPONENTS[this.props.mfaMechanism];
    return (
      <Component
        {...this.props}
        onLoginWithMfa={this.onLoginWithMfa}
        onResendOtp={this.onResendOtp}
      />
    );
  }
}
